/** @format */

import styles from "../../../styles/Components/trade-assistant/assistant/AiAssistantTableActionButtons.module.css";
import { useDispatch, useSelector } from "react-redux";
import { Button, Dropdown } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import {
  getAllTradeSuggestion,
  getTradeAssistant,
  setAiAssistantMode,
  setAIMarketType,
  setViewType,
  setTimeFrame,
} from "../../../redux/trading-assistant/actions";
import { FiRefreshCcw } from "react-icons/fi";
import {
  FaBalanceScale,
  FaBitcoin,
  FaCity,
  FaExclamationTriangle,
  FaFlag,
  FaGlobeAsia,
  FaLandmark,
  FaLink,
  FaMoneyBillWave,
  FaShieldAlt,
  FaSun,
  FaUniversity,
  FaBolt,
  FaClock,
} from "react-icons/fa";
import { LIVE_AI_ITEMS, clearLiveSymbols, normalizeLiveTimeframe, setLiveAiTimeframe, setUsPreset } from "../../../redux/live-suggestion/liveSuggestionSlice";
import { US_PRESETS, boardSymbols, isStockBoard } from "../../../shared/stockBoards";
import { loadExtraSymbols } from "../../../shared/extraSymbols";
import {
  BsExclamationTriangleFill,
  BsPeople,
  BsGrid,
  BsListUl,
} from "react-icons/bs";
import { HiRocketLaunch } from "react-icons/hi2";
import { AiTwotoneFire } from "react-icons/ai";
import { updateProfile } from "../../../redux/profile/actions";
import { BiCategory } from "react-icons/bi";
import { MdShowChart } from "react-icons/md";
import ActionButtonsWrapper from "../../../ui/ActionButtonsWrapper";
import ActionButton from "../../../ui/ActionButton";
import MarketTypePicker from "../../../shared/MarketTypePicker";
import pickerStyles from "../../../styles/shared/MarketTypePicker.module.css";

const categoryItems = [
  {
    key: "only_ai",
    label: "AI",
    icon: <AiTwotoneFire />,
  },
  {
    key: "null",
    label: "Combined",
    icon: <BiCategory />,
  },
  {
    key: "only_ta",
    label: "Technical Indicators",
    icon: <MdShowChart />,
  },
  {
    key: "only_onchain",
    label: "On Chain",
    icon: <FaLink />,
  },
  {
    key: "only_social",
    label: "Social",
    icon: <BsPeople />,
  },
  {
    key: "only_fred",
    label: "FRED",
    icon: <FaLandmark />,
  },
];

const riskOptions = [
  {
    label: "Very Cautious",
    key: "1",
    icon: <FaShieldAlt />,
  },
  {
    label: "Cautious",
    key: "2",
    icon: <BsExclamationTriangleFill />,
  },
  {
    label: "Balanced",
    key: "3",
    icon: <FaBalanceScale />,
  },
  {
    label: "Adventurous",
    key: "4",
    icon: <HiRocketLaunch />,
  },
  {
    label: "Very Adventurous",
    key: "5",
    icon: <AiTwotoneFire />,
  },
];

export const marketItems = [
  {
    label: "Crypto",
    key: "crypto",
    icon: <FaBitcoin />, // Represents cryptocurrency
  },
  {
    label: "Forex",
    key: "forex",
    icon: <FaMoneyBillWave />, // Represents currency exchange
  },
  {
    label: "US",
    key: "us",
    icon: <FaUniversity />,
  },
  {
    label: "Indonesia",
    key: "indonesia",
    icon: <FaGlobeAsia />,
  },
  {
    label: "Iran",
    key: "iran",
    icon: <FaFlag />,
  },
  {
    label: "Australia",
    key: "australia",
    icon: <FaSun />,
  },
  {
    label: "Japan",
    key: "japan",
    icon: <FaLandmark />,
  },
  {
    label: "KSA",
    key: "ksa",
    icon: <FaCity />,
  },
];

function AiAssistantTableActionButtons() {
  const {
    profile: { profileData = {} },
    tradingAssistant: {
      timeFrames,
      getTradeAssistantLoading,
      aiMarketType,
      selectedPortfolio,
      aiAssistantMode,
      categoryGoodness,
      viewType,
      selectedTimeFrame,
    },
    main: { userData },
    liveSuggestion: { liveTimeframe, usPreset },
  } = useSelector((state) => state);

  const [risk, setRisk] = useState(
    profileData?.ai_assistant_risk_appetite || "1",
  );

  const visibleCategoryItems = categoryItems.filter((item) => {
    if (
      aiMarketType === "forex" &&
      (item.key === "only_onchain" || item.key === "only_social")
    ) {
      return false;
    }
    return true;
  });

  const currentCategory =
    visibleCategoryItems?.find((item) => item.key === aiAssistantMode)?.label ||
    "Combined";

  const currentRisk = riskOptions?.find((item) => item.key === risk)?.label;

  const timeFrameItems = useMemo(() => {
    return (
      timeFrames?.map((timeFrame) => ({
        label: timeFrame?.includes("m") ? timeFrame : timeFrame.toUpperCase(),
        key: timeFrame,
        icon: <FaClock />,
      })) || []
    );
  }, [timeFrames]);

  const currentTimeFrame = timeFrameItems?.find(
    (item) => item.key === selectedTimeFrame,
  )?.label;

  const dispatch = useDispatch();

  const isServiceActive = profileData?.myais_active === "True";
  const stockBoard = isStockBoard(aiMarketType);

  const disabledStyle = {
    opacity: `${getTradeAssistantLoading ? 0.8 : 1}`,
    cursor: `${getTradeAssistantLoading ? "not-allowed" : "pointer"}`,
  };

  const handleRefresh = () => {
    if (stockBoard) {
      dispatch(clearLiveSymbols(boardSymbols(aiMarketType, loadExtraSymbols(aiMarketType), usPreset)));
      return;
    }
    if (getTradeAssistantLoading) return;
    dispatch(
      getTradeAssistant(
        userData?.["cognito:username"],
        userData?.["custom:custom_username"],
        "primary",
        aiMarketType,
        isServiceActive,
        aiAssistantMode,
        true,
      ),
    );
    // dispatch(
    //   getAllTradeSuggestion(
    //     userData?.["custom:custom_username"],
    //     userData?.["cognito:username"],
    //     aiMarketType,
    //     isServiceActive,
    //   ),
    // );
  };

  const handleRiskAppetite = (e) => {
    let attribute_names = ["ai_assistant_risk_appetite"];
    setRisk(e.key);

    dispatch(
      updateProfile(
        userData?.email,
        userData["custom:custom_username"],
        attribute_names,
        [e.key],
      ),
    );
    dispatch(
      getTradeAssistant(
        userData?.["cognito:username"],
        userData?.["custom:custom_username"],
        selectedPortfolio,
        aiMarketType,
        isServiceActive,
        aiAssistantMode,
      ),
    );
  };

  const handleChangeCategory = (e) => {
    dispatch(setAiAssistantMode(e.key));
    dispatch(
      getTradeAssistant(
        userData?.["cognito:username"],
        userData?.["custom:custom_username"],
        selectedPortfolio,
        aiMarketType,
        isServiceActive,
        e.key,
      ),
    );
  };

  const handleChangeMarketType = (e) => {
    dispatch(setAIMarketType(e.key));
    if (isStockBoard(e.key)) return;
    let mode = aiAssistantMode;
    if (
      e.key === "forex" &&
      (mode === "only_onchain" || mode === "only_social")
    ) {
      mode = "null";
      dispatch(setAiAssistantMode("null"));
    }
    dispatch(
      getTradeAssistant(
        userData?.["cognito:username"],
        userData?.["custom:custom_username"],
        selectedPortfolio?.toLowerCase() || "primary",
        e.key,
        isServiceActive,
        mode,
      ),
    );
  };

  const handleViewToggle = (viewType) => {
    dispatch(setViewType(viewType));
  };

  const handleTimeFrameChange = (e) => {
    dispatch(setTimeFrame(e.key));
  };

  const riskMenu = useMemo(() => {
    return {
      items: riskOptions,
      onClick: handleRiskAppetite,
      selectedKeys: [risk],
    };
  }, [handleRiskAppetite, risk]);

  useEffect(() => {
    if (aiMarketType === "asx") dispatch(setAIMarketType("australia"));
  }, [aiMarketType, dispatch]);

  const categoryMenu = {
    items: visibleCategoryItems,
    onClick: handleChangeCategory,
    selectedKeys: [aiAssistantMode || "null"],
  };

  const timeFrameMenu = {
    items: timeFrameItems,
    onClick: handleTimeFrameChange,
    selectedKeys: [selectedTimeFrame || "1h"],
  };

  const categoryLabel = (item) => {
    const score =
      categoryGoodness?.[item.key] ??
      categoryGoodness?.[item.key === "null" ? "default" : item.key];
    const n = Number(score);
    if (!Number.isFinite(n)) return item.label;
    return `${item.label} ${Math.round(n)}%`;
  };

  return (
    <>
      <div className={pickerStyles.desktopOnly}>
        <MarketTypePicker
          layout="inline"
          value={aiMarketType || "crypto"}
          onChange={(key) => handleChangeMarketType({ key })}
        />
        {!stockBoard && (
          <div className={styles.chipRow}>
            {visibleCategoryItems.map((item) => (
              <button
                key={item.key}
                type="button"
                className={`${styles.chip} ${(aiAssistantMode || "null") === item.key ? styles.chipSelected : ""}`}
                onClick={() => handleChangeCategory({ key: item.key })}
              >
                {item.icon}
                {categoryLabel(item)}
              </button>
            ))}
          </div>
        )}
      </div>
      {aiMarketType === "us" && (
        <div className={styles.chipRow}>
          {Object.entries(US_PRESETS).map(([key, preset]) => (
            <button
              key={key}
              type="button"
              className={`${styles.chip} ${(usPreset || "all") === key ? styles.chipSelected : ""}`}
              onClick={() => dispatch(setUsPreset(key))}
            >
              {preset.label}
            </button>
          ))}
        </div>
      )}
      <ActionButtonsWrapper>
      {!stockBoard && (
        <>
          <ActionButton
            icon={<FaExclamationTriangle />}
            label="Risk"
            value={currentRisk}
            dropdownOptions={riskMenu}
          />
          <ActionButton
            className={pickerStyles.mobileOnly}
            icon={<BiCategory />}
            label="Category"
            value={currentCategory}
            dropdownOptions={categoryMenu}
          />
        </>
      )}
      <MarketTypePicker
        className={pickerStyles.mobileOnly}
        value={aiMarketType || "crypto"}
        onChange={(key) => handleChangeMarketType({ key })}
      />
      {aiMarketType === "crypto" && (
        <ActionButton
          icon={<FaBolt />}
          label="Pivot"
          value={normalizeLiveTimeframe(liveTimeframe)}
          dropdownOptions={{
            items: LIVE_AI_ITEMS,
            onClick: (event) => dispatch(setLiveAiTimeframe(event.key)),
            selectedKeys: [normalizeLiveTimeframe(liveTimeframe)],
          }}
        />
      )}
      {stockBoard && (
        <ActionButton icon={<FaBolt />} label="Pivot" value="1d" />
      )}
      {!stockBoard && (
        <>
          <ActionButton
            icon={<FaClock />}
            label="Time frame"
            value={currentTimeFrame}
            dropdownOptions={timeFrameMenu}
          />
          <ActionButton isToggle>
            <span>View: </span>
            <div className={styles.viewToggle}>
              <span
                className={viewType === "card" ? styles.activeView : ""}
                onClick={() => handleViewToggle("card")}
              >
                <BsGrid size={12} />
              </span>
              <span
                className={viewType === "list" ? styles.activeView : ""}
                onClick={() => handleViewToggle("list")}
              >
                <BsListUl size={12} />
              </span>
            </div>
          </ActionButton>
        </>
      )}
      <ActionButton
        icon={<FiRefreshCcw />}
        label="Refresh"
        onClick={handleRefresh}
        loading={!stockBoard && getTradeAssistantLoading}
        useAntdButton
      />
    </ActionButtonsWrapper>
    </>
  );

  // return (
  //   <div className={styles.container}>
  //     <li className={styles.button}>
  //       <Button loading={getTradeAssistantLoading} onClick={handleRefresh}>
  //         {!getTradeAssistantLoading && <FiRefreshCcw color="#2A86FF" />}
  //         Refresh
  //       </Button>
  //     </li>
  //
  //     <li className={`${styles.button} ${styles.displayOnly}`}>
  //       <Link to="/bot-automation">
  //         <FaRobot color="#2A86FF" size={15} />
  //         Bot: <span className={styles.status}>{botStatus}</span>
  //       </Link>
  //     </li>
  //
  //     <li className={`${styles.button} ${styles.displayOnly}`}>
  //       <Link to="/alert-system">
  //         <FaBell color="#2A86FF" size={15} />
  //         Alert: <span className={styles.status}>{alert}</span>
  //       </Link>
  //     </li>
  //
  //     <Dropdown
  //       menu={riskMenu}
  //       trigger={["click"]}
  //       disabled={getTradeAssistantLoading}
  //     >
  //       <li className={styles.button} style={disabledStyle}>
  //         <FaExclamationTriangle color="#2A86FF" />
  //         Risk:
  //         <span className={styles.status}>{currentRisk}</span>
  //       </li>
  //     </Dropdown>
  //     <Dropdown
  //       menu={categoryMenu}
  //       trigger={["click"]}
  //       disabled={getTradeAssistantLoading}
  //     >
  //       <li className={styles.button} style={disabledStyle}>
  //         <BiCategory color="#2A86FF" />
  //         Category:
  //         <span className={styles.status}>{currentCategory}</span>
  //       </li>
  //     </Dropdown>
  //
  //     <Dropdown
  //       menu={marketMenu}
  //       trigger={["click"]}
  //       disabled={getTradeAssistantLoading}
  //     >
  //       <li className={styles.button} style={disabledStyle}>
  //         <FaChartLine color="#2A86FF" />
  //         Market type:
  //         <span className={styles.status}>{currentMarket}</span>
  //       </li>
  //     </Dropdown>
  //
  //     <div className={styles.button}>
  //       <span>View: </span>
  //       <div className={styles.viewToggle}>
  //         <span
  //           className={viewType === "card" ? styles.activeView : ""}
  //           onClick={() => handleViewToggle("card")}
  //         >
  //           <BsGrid size={12} />
  //         </span>
  //         <span
  //           className={viewType === "list" ? styles.activeView : ""}
  //           onClick={() => handleViewToggle("list")}
  //         >
  //           <BsListUl size={12} />
  //         </span>
  //       </div>
  //     </div>
  //   </div>
  // );
}

export default AiAssistantTableActionButtons;
